interface MyButtonProperties {
  label: string;
  disableHoverEffect?: boolean;
  buttonType:
    | 'submit'
    | 'back'
    | 'error'
    | 'gray'
    | 'outline'
    | 'active-outline'
    | 'warning'
    | 'primary-outline'
    | 'none'
    | 'hover'
    | 'danger-outline'
    | 'primary-outline-none'
    | 'primary'
    | 'force';
  svgIcon?: JSX.Element;
  svgBackIcon?: JSX.Element;
  onClickFunc?: () => void;
  disabled?: boolean;
  loading?: boolean;
  hoverLabel?: string;
  labelColorFill?: string;
  svgColorFill?: string;
}

/**
 * My Button function component
 */
function MyButton({
  label,
  buttonType,
  svgIcon,
  onClickFunc,
  disableHoverEffect,
  svgBackIcon,
  disabled,
  loading,
  hoverLabel,
  labelColorFill,
  svgColorFill,
}: MyButtonProperties) {
  return (
    <div className="button-wrap">
      <button
        type="button"
        className={`${buttonType}-button ${disableHoverEffect ? '' : 'on-hover'}`}
        onClick={onClickFunc}
        disabled={disabled}>
        {svgIcon && (
          <span className="icon" style={{ color: svgColorFill }}>
            {svgIcon}
          </span>
        )}
        {label && <span style={{ color: labelColorFill }}>{label}</span>}
        {svgBackIcon && <span className="icon">{svgBackIcon}</span>}
      </button>
      {hoverLabel && <div className="hover-label">{hoverLabel}</div>}
      {loading && (
        <div className="button-loader-wrap">
          <div className="button-loader-container">
            <div className="button-loader" />
          </div>
        </div>
      )}
    </div>
  );
}

MyButton.defaultProps = {
  onClickFunc: null,
  svgIcon: null,
  svgBackIcon: null,
  disabled: false,
  loading: false,
  disableHoverEffect: false,
  hoverLabel: '',
  labelColorFill: '',
  svgColorFill: '',
};

export default MyButton;
